module.exports = __webpack_public_path__ + "img/aParty_042724_D.fbff2a39.jpg";